module.exports = __webpack_public_path__ + "img/left_one.82184acd.png";